import styled from 'styled-components';
import "../../styles/base/_animation.scss";
import { colorPrimaryDark1, colorPrimaryDark2, colorPrimary } from '../../styles/abstract/variables';
import { HeroType } from './hero.component';

export const HeroStyled = styled.div`
    position: relative;
        min-height: ${(props) => (props.heroType === HeroType.DetailPage ? '70vh' : '120vh')};
    background-image: ${(props) => `linear-gradient(
        to bottom, 
        rgba(${colorPrimaryDark2}, .2) 0%, 
        rgba(${colorPrimaryDark2}, .75) 85%, 
        rgba(${colorPrimaryDark1}, .85) 95%, 
        rgba(${colorPrimaryDark1}, 1) 100%),
        url(${props.image})`};
    background-size: cover;
    background-repeat: no-repeat;
    background-clip: border-box;
    background-position: center;
`;

export const HeroMinimalist = styled.div`
    position: relative;
    min-height: 35vh;
    background-color: ${colorPrimary};
`;

export const HeroContentminimalist = styled.div `
    text-align: center;
    padding-bottom: 2rem;
`

export const HeroContentStyled = styled.div `
    position: relative;
    text-align: center;
    width: 100%;
    padding-top: 8rem;
`